module.exports = __webpack_public_path__ + "img/plus-green.52a8c120.svg";